'use strict';
var retrys = 0,
    maxretrys = 7,
    restartupdate = '';

function isRecord(value) {
    return value !== null && typeof value === 'object';
}

function eachPlayers(players, callback) {
    if ($.isArray(players)) {
        $.each(players, callback);
    }
}
jQuery(function () {
    update();
    $('li.search>button').click(function (event) {
        event.preventDefault();
        $('p.search').stop(true, false).slideToggle(300);
    });
    $('.tabnav button.teams').click(function () {
        window.location.href = '/t/';
    });
    $('.tabnav li:not(.search) button:not(.teams)').click(function (event) {
        event.preventDefault();
        var el = $(this);
        var activeTab = '#' + el.data('tab');
        window.location.hash = activeTab;
        if (activeTab == '#all') {
            $('.tabnav button.active').removeClass('active');
            el.addClass('active');
            $('.tab').stop(true, false).slideDown(400, 'easeInOutExpo');
            return false;
        }
        if (el.hasClass('active')) {
            $(activeTab).stop(true, false).slideUp(400, 'easeInOutExpo');
            el.removeClass('active');
        } else {
            $('.tabnav button.active').removeClass('active');
            $('.tab').hide();
            $(activeTab).fadeIn(200);
            el.addClass('active');
        }
        return false;
    });
    $('.updater').click(function (event) {
        if ($('body').hasClass('paused')) {
            $('body').removeClass('paused');
            $('.updater div').append('<span />');
            clearTimeout(restartupdate);
            update();
        } else {
            clearTimeout(restartupdate);
            $('body').addClass('paused');
            $('.updater span').remove();
        }
    });

    $(document).on('click', '.btn-restart', function () {
        $('.updater').removeClass('loading');
        $('.loader').fadeIn(300);
        $('body').removeClass('started');
        $('#main>.error').slideUp(300).delay(300).remove();
        update();
    });
});
function jsonError() {
    console.log('failed');
    console.log(retrys, maxretrys);
    $('.loader').fadeOut(300);
    $('.tab:not(#maps)').fadeOut(300);
    $('.updater').removeClass('loading');
    $('#main>.error').remove();
    $('body').removeClass('error');
    $('#main').prepend(
        '<div class="error"><h2 style="padding-top:30px;">Server Offline</h2><p class="error" style="margin-bottom:30px; padding-bottom:30px;">API request failed: <a class="btn-restart" style="cursor:pointer; border-bottom: 1px solid">Reload</a></a></p></div>',
    );
    $('body').addClass('error');
    if (retrys < maxretrys) {
        clearTimeout(restartupdate);
        restartupdate = setTimeout(function () {
            update();
        }, 6000);
        ++retrys;
        return;
    }
    clearTimeout(restartupdate);
    restartupdate = setTimeout(function () {
        update();
    }, 30000);
}
var update = function () {
    //$.getJSON( 'https://cors.io/?https://info.server.cnc-online.net/' , function() {})
    //$.getJSON( 'https://cors-anywhere.herokuapp.com/https://info.server.cnc-online.net/' , function() {})
    $.getJSON('feed.php', function () {})
        .fail(function () {
            jsonError();
        })
        .done(function (data) {
            log(data);
            if (
                !isRecord(data) ||
                data.error ||
                !isRecord(data.games) ||
                !isRecord(data.games.staging) ||
                !isRecord(data.games.playing) ||
                !isRecord(data.users)
            ) {
                jsonError();
                return;
            }
            if ($('body').hasClass('error')) {
                $('body').removeClass('error');
                $('.btn-restart').click();
            }
            console.log('updated');
            if ($('body').hasClass('paused')) {
                clearTimeout(restartupdate);
                return;
            }
            if (!$('body').hasClass('started')) {
                $('.tab').fadeIn(300);
                $('.loader').fadeOut(300);
                $('.updater').removeClass('loading');
                $('body').addClass('started');
                if (window.location.hash) {
                    var current = window.location.hash;
                    current = current.replace('#', '');
                    $('button[data-tab="' + current + '"]').click();
                }
            }
            var roomsdata = data.games.staging,
                roomshtml = '',
                roomshtmlpw = '',
                roomscount = 0,
                gamesdata = data.games.playing,
                gameshtml = '',
                gameshtmlpw = '',
                gamescount = 0,
                usersdata = data.users,
                usershtml = '',
                usercount = 0,
                ingame = '',
                ingamecount = 0,
                inroom = '',
                inroomcount = 0;
            $.each(roomsdata, function (k, v) {
                ++roomscount;
                var players = v.players;
                var playershtml = '';
                eachPlayers(players, function (key, val) {
                    ++inroomcount;
                    inroom +=
                        '<li><a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' +
                        val.pid +
                        '"><span>' +
                        val.nickname +
                        '</span></a></li>';
                    if (key == 0) {
                        playershtml +=
                            '<strong><a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' +
                            val.pid +
                            '">' +
                            val.nickname +
                            '</a></strong>';
                    } else {
                        playershtml +=
                            ', <a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' + val.pid + '">' + val.nickname + '</a>';
                    }
                });

                var pass = v.pw == 1 ? '<i class="fas fa-lock" style="font-size:12px; opacity: .5; margin-right:5px" ></i>' : '';
                if (pass) {
                    roomshtmlpw +=
                        '\
                <ul class="room" data-id="' +
                        v.host.pid +
                        '">\
                <li class="players"><span>Players: </span> <strong>' +
                        v.numplayers +
                        ' / ' +
                        v.maxRealPlayers +
                        '</strong></li>\
                <li class="map"><span>Map: </span>' +
                        v.map +
                        '<br><em class="sm">' +
                        v.version +
                        '</em></li>\
                <li class="title"><span>Title: </span> ' +
                        pass +
                        ' <strong><a target="_blank" href="https://cnc3kw.com/live?id=' +
                        v.host.id +
                        '">' +
                        v.title +
                        '</a></strong></li>\
                <li class="users"><span>Users: </span> ' +
                        playershtml +
                        '</li>\
                </ul>';
                } else {
                    roomshtml +=
                        '\
                <ul class="room" data-id="' +
                        v.host.pid +
                        '">\
                <li class="players"><span>Players: </span> <strong>' +
                        v.numplayers +
                        ' / ' +
                        v.maxRealPlayers +
                        '</strong></li>\
                <li class="map"><span>Map: </span>' +
                        v.map +
                        '<br><em class="sm">' +
                        v.version +
                        '</em></li>\
                <li class="title"><span>Title: </span> ' +
                        pass +
                        ' <strong><a target="_blank" href="https://cnc3kw.com/live?id=' +
                        v.host.id +
                        '">' +
                        v.title +
                        '</a></strong></li>\
                <li class="users"><span>Users: </span> ' +
                        playershtml +
                        '</li>\
                </ul>';
                }
            });
            $.each(gamesdata, function (k, v) {
                ++gamescount;
                var players = v.players;
                var playershtml = '';
                eachPlayers(players, function (key, val) {
                    ++ingamecount;
                    ingame +=
                        '<li><a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' +
                        val.pid +
                        '"><span>' +
                        val.nickname +
                        '</span></a></li>';
                    if (key == 0) {
                        playershtml +=
                            '<strong><a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' +
                            val.pid +
                            '">' +
                            val.nickname +
                            '</a></strong>';
                    } else {
                        playershtml +=
                            ', <a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' + val.pid + '">' + val.nickname + '</a>';
                    }
                });
                var pass = v.pw == 1 ? '<i class="fas fa-lock" style="font-size:12px; opacity: .5; margin-right:5px" ></i>' : '';
                if (pass) {
                    gameshtmlpw +=
                        '\
                <ul class="room" data-id="' +
                        v.host.pid +
                        '">\
                <li class="players"><span>Players: </span> <strong>' +
                        v.numplayers +
                        ' / ' +
                        v.maxRealPlayers +
                        '</strong></li>\
                <li class="map"><span>Map: </span> <strong>' +
                        v.map +
                        '<br><em class="sm">' +
                        v.version +
                        '</em></strong></li>\
                <li class="title"><span>Title: </span> ' +
                        pass +
                        ' <strong><a target="_blank" href="https://cnc3kw.com/live?id=' +
                        v.host.id +
                        '">' +
                        v.title +
                        '</a></strong></li>\
                <li class="users"><span>Users: </span> ' +
                        playershtml +
                        '</li>\
                </ul>';
                } else {
                    gameshtml +=
                        '\
                <ul class="room" data-id="' +
                        v.host.pid +
                        '">\
                <li class="players"><span>Players: </span> <strong>' +
                        v.numplayers +
                        ' / ' +
                        v.maxRealPlayers +
                        '</strong></li>\
                <li class="map"><span>Map: </span> <strong>' +
                        v.map +
                        '<br><em class="sm">' +
                        v.version +
                        '</em></strong></li>\
                <li class="title"><span>Title: </span> ' +
                        pass +
                        ' <strong><a target="_blank" href="https://cnc3kw.com/live?id=' +
                        v.host.id +
                        '">' +
                        v.title +
                        '</a></strong></li>\
                <li class="users"><span>Users: </span> ' +
                        playershtml +
                        '</li>\
                </ul>';
                }
            });
            $.each(usersdata, function (key, v) {
                usershtml +=
                    '<li><a target="_blank" href="http://www.shatabrick.com/cco/kw/index.php?g=kw&a=sp&id=' +
                    v.pid +
                    '"><span>' +
                    v.nickname +
                    '</span></a></li>';
                ++usercount;
            });
            $('#rooms div.data').html(roomshtml + roomshtmlpw);
            $('#games div.data').html(gameshtml + gameshtmlpw);
            $('#users ul').html(usershtml);
            $('#users ul.ingame').html(ingame);
            $('#users ul.inroom').html(inroom);
            jQuery('[data-field]').each(function () {
                var el = $(this);
                var field = el.attr('data-field');
                if (field == 'users') {
                    el.html(usercount);
                }
                if (field == 'inroom') {
                    el.html(inroomcount);
                }
                if (field == 'ingame') {
                    el.html(ingamecount);
                }
                if (field == 'games') {
                    el.html(gamescount);
                    if (gamescount == 0) {
                        $('#games ul.headings').hide();
                    } else {
                        $('#games ul.headings').show();
                    }
                }
                if (field == 'rooms') {
                    el.html(roomscount);
                    if (roomscount == 0) {
                        $('#rooms ul.headings').hide();
                    } else {
                        $('#rooms ul.headings').show();
                    }
                }
            });
            updateList();
        });
    $('ul.room').click(function () {
        var el = $(this);
        var id = el.data('id');
        log(id);
    });
    $('.updater>div').html('<span />').fadeIn(300);
    $('.updater span').animate({ width: '100%' }, 5700, function () {
        $('.updater span').fadeOut(300);
    });
    clearTimeout(restartupdate);
    restartupdate = setTimeout(function () {
        update();
    }, 6000);
};
if (!!$('#search').length) {
    $.extend($.expr[':'], {
        containsIN: function (elem, i, match, array) {
            return (elem.textContent || elem.innerText || '').toLowerCase().indexOf((match[3] || '').toLowerCase()) >= 0;
        },
    });
    var updateList = function () {
        var allRooms = $('.room');
        allRooms.removeClass('hiddenRow');
        var allUsers = $('#users ul li');
        allUsers.removeClass('hiddenRow');
        var clickedText = $('#search').val();
        allRooms.each(function () {
            if (!$(this).is(':containsIN("' + clickedText + '")')) {
                $(this).addClass('hiddenRow');
            }
        });
        allUsers.each(function () {
            if (!$(this).is(':containsIN("' + clickedText + '")')) {
                $(this).addClass('hiddenRow');
            }
        });
    };
    $('#search').keyup(function (e) {
        updateList();
    });
    $('#search').blur(function (e) {
        updateList();
    });
}
function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}
